export default {"src":"/_next/static/media/instagram.cd8d1cc1.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};